import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography
} from 'antd';
import { default as React, useEffect, useState } from 'react';
import { renderConditionalOptions } from '../../../utilities/formHelpers';
import '../../Common/Form.css';
import { reasonTypesList, refundMethodsList } from '../constants';

const { Option } = Select;
const { Text } = Typography;

function RefundForm(props) {
  const { initialValues, onSubmit, status } = props;
  const [isReasonCustom, setIsReasonCustom] = useState(false);

  const [form] = Form.useForm();

  const reasonTypesListMenu = reasonTypesList.map((option) => (
    <Option value={option.value}>{option.name}</Option>
  ));
  const refundMethodsListMenu = refundMethodsList.map((option) => (
    <Option value={option.value}>{option.name}</Option>
  ));

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues]);

  function onReasonTypeChange(e) {
    let reasonType = form.getFieldValue('reasonType');
    if (reasonType != 'CUSTOM') {
      setIsReasonCustom(false);
      let filteredReason = reasonTypesList.filter(
        (item) => item.value === reasonType
      );
      if (filteredReason && filteredReason.length > 0) {
        form.setFieldsValue({ reason: filteredReason[0].name });
      }
    } else {
      setIsReasonCustom(true);
    }
  }

  function onFinish(values) {
    let reasonType = form.getFieldValue('reasonType');
    if (reasonType != 'CUSTOM') {
      let filteredReason = reasonTypesList.filter(
        (item) => item.value === reasonType
      );
      if (filteredReason && filteredReason.length > 0) {
        values.reason = filteredReason[0].name;
      }
    }
    delete values.reasonType;
    onSubmit({ ...initialValues, ...values });
  }

  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onFinish}
      initialValues={initialValues}
      form={form}
      layout="vertical">
      <Row>
        <Col span={24}>
          <Form.Item
            label="Reason"
            name="reasonType"
            rules={[
              {
                required: !isReasonCustom,
                message: 'Please select reason!'
              }
            ]}>
            <Select
              onChange={(value) => onReasonTypeChange(value)}
              placeholder="Select Type of Reason">
              {reasonTypesListMenu}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            label="Reason Description"
            name="reason"
            hidden={!isReasonCustom}
            rules={[
              {
                required: isReasonCustom,
                whitespace: false,
                message: 'Please input promo code!'
              }
            ]}>
            <Input defaultValue={initialValues.reason} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            label="Refund Method"
            name="refundMethod"
            rules={[
              {
                required: !isReasonCustom,
                message: 'Please select refund method!'
              }
            ]}>
            <Select placeholder="Select Refund Method">
              {refundMethodsListMenu}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            label="Is Refund Partial?"
            name="isPartial"
            rules={[{ required: true }]}>
            <Select defaultValue={initialValues.isPartial}>
              {renderConditionalOptions([
                'For discount claims',
                'Full refunds to withdraw the student'
              ])}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item
            label="Refund Currency"
            name="localCurrency"
            rules={[
              {
                required: true,
                message: 'Please input refund currency!'
              },
              {
                required: true,
                type: 'regexp',
                pattern: new RegExp('/^[A-Za-z]+$/'),
                message: 'field only accepts alphabets'
              }
            ]}>
            <Input defaultValue={initialValues.localCurrency} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Refund Amount"
            name="localAmount"
            rules={[
              {
                required: true,
                message: 'Please input refund amount'
              }
            ]}>
            <InputNumber
              min={0}
              defaultValue={initialValues.localAmount}
            />
          </Form.Item>
        </Col>
      </Row>
      {status.type === 'SUCCESS' ? (
        <Text type="success">Successful!</Text>
      ) : status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            Confirm
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default RefundForm;
